import { render, staticRenderFns } from "./ForumResponseTimestamp.vue?vue&type=template&id=5a16e628&scoped=true"
import script from "./ForumResponseTimestamp.vue?vue&type=script&lang=js"
export * from "./ForumResponseTimestamp.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseTimestamp.vue?vue&type=style&index=0&id=5a16e628&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a16e628",
  null
  
)

export default component.exports